import React from "react";
import SVG from "react-inlinesvg";
import { useSudowriteStore } from "../../stores/sudowriteStore";
import { StyledContainer } from "./styles";

export default function RewriteMenu({ onClose }) {
  return (
    <StyledContainer data-testid="rewrite-options-menu">
      <button
        type="button"
        className="settings-row use-component-styles"
        aria-label="Open Writing settings"
        onClick={() => {
          onClose?.();
          useSudowriteStore.getState().openStyleSettings("writing");
        }}
      >
        <SVG
          src="/assets/settings.svg"
          width={24}
          height={24}
          aria-hidden="true"
        />
        <span>Settings</span>
      </button>
    </StyledContainer>
  );
}
